import React, { ReactElement } from 'react';
import { LoaderButton } from 'idsk-react-components';
import uuid from '../../../../../../model/Uuid';
import { useSuccessMessageContext } from '../../../../../../context/SuccessMessageContext';
import { useClient } from '../../../../../../context/ClientStatusContext';
import {
  deleteSledovatel,
} from '../../../../../../client/external/evidencnaaplikacia/legislativnyMaterialSledovatelClient';
import iconNesledovat from '../../../../../../../assets/images/icon-nesledovat.svg';

interface Props {
  legMaterialUuid: uuid;
  updateMaterial: () => void;
  buttonText: string,
  buttonStyle?: 'third' | 'link-negative';
  size?: 'small' | 'medium' | 'large';
  icon?: boolean;
}

export default function SledovatelDeleteButton({
  legMaterialUuid,
  updateMaterial,
  buttonText,
  buttonStyle = 'third',
  size = 'large',
  icon = true,
}: Props): ReactElement {
  const { displaySuccess } = useSuccessMessageContext();
  const {
    wrapClient: deleteSledovatelClient,
    status: deleteSledovatelStatus,
  } = useClient(deleteSledovatel);

  function successAndScroll(message: string): void {
    displaySuccess(message);
    document.querySelector('.success-message')
      ?.scrollIntoView({ behavior: 'smooth' });
  }

  const deleteSledovatelMaterial = async (): Promise<void> => {
    await deleteSledovatelClient(legMaterialUuid);
    updateMaterial();
    successAndScroll('Proces bol odstránený zo zoznamu sledovaných procesov.');
  };

  return (
    <LoaderButton
      buttonStyle={buttonStyle}
      className="action__button"
      size={size}
      customIconBefore={icon ? iconNesledovat : undefined}
      onClick={deleteSledovatelMaterial}
      loading={deleteSledovatelStatus.loading}
      disableOutsideClickWhileLoading
    >{buttonText}
    </LoaderButton>
  );
}
